module.exports = __webpack_public_path__ + "static/media/Docbuilder-coming-soon.4b7654e9.png";